import { Injectable } from '@angular/core';
import { SystemLanguage } from '@app/user';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class SubtitlesService {
    private readonly choosenLangs = new BehaviorSubject<(SystemLanguage | undefined)[]>([]);
    private readonly validating = new BehaviorSubject<boolean>(false);
    readonly choosenLangs$ = this.choosenLangs.asObservable();
    readonly validating$ = this.validating.asObservable();

    setLangs(langs: (SystemLanguage | undefined)[]) {
        this.choosenLangs.next(langs);
    }

    setValidating(validating: boolean) {
        this.validating.next(validating);
    }
}
